import React, { Component } from "react";
import { Button, Icon, Modal } from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import styled from "styled-components";
import DownloadSampleProduct from "../../modules/ClientDashboard/DownloadSampleProduct";

const StyledModal = styled(Modal).attrs()`
  width: 1000px;
  overflow: hidden;
  max-height: 574px;
`;

const StyledTable = styled.table`
  max-height: 267px;
`;
const StyledRowHead = styled.td`
  min-width: 210px;
  padding: 16px 14px;
  background-color: ${(props) => props.theme.palette.light.c100};
  border: 1px solid ${(props) => props.theme.palette.light.c200};
`;

const StyledTd = styled.td`
  min-width: 210px;
  vertical-align: top;
  border: 1px solid ${(props) => props.theme.palette.light.c100};
`;
const StyledList = styled.ul`
  list-style: none;
  padding: 0;
`;

const reward_labels = [
  "reward points",
  "reward codes",
  "reward links",
  "gift cards",
];

class TemplateGuideModal extends Component {
  state = {
    modal: true,
  };

  componentWillMount() {
    this.setState(this.props);
  }

  handleModal = () => {
    this.setState({
      modal: false,
    });
    this.props.modalStatus ? this.props.modalStatus() : null;
  };

  render() {
    const { modal } = this.state;
    const { title = "" } = this.props;
    const dataModal = [
      {
        tagName: "Name",
        value: "name",
        conditions: [
          title === "Gift Cards" ? "Optional." : "Mandatory.",
          "Max character is 70.",
        ],
      },
      {
        tagName: "Email",
        value: "email",
        conditions: ["Either email or mobile number is mandatory."],
      },
      {
        tagName: "Country Code",
        value: "country",
        conditions: ["Mandatory if mobile number column is used."],
      },
      {
        tagName: "Mobile number",
        value: "mobile",
        conditions: [
          "Either email or mobile number is mandatory.",
          "Between 7 to 16 digits.",
        ],
      },
      {
        tagName: "Value of Code",
        desc: "Value of the Xoxo Reward Code that needs to be sent.",
        ex: "Ex: 1000",
        value: "amount",
        conditions: ["Mandatory.", "Between 1 and 50000."],
      },
      {
        tagName: "Value of points",
        desc: "Total Xoxo Reward Points that needs to be sent.",
        ex: "Ex: 1000",
        value: "amount_points",
        conditions: ["Mandatory.", " Cannot be less than 1."],
      },
      {
        tagName: "Quantity",
        desc: "No. of reward codes that needs to be sent.",
        ex: "Ex: 10",
        value: "quantity",
        conditions: ["Mandatory.", "Between 1 and 50."],
      },
      {
        tagName: "Scheduled Date",
        value: "schedulerPoints",
        conditions: [
          "Optional.",
          "If left blank, reward will be sent immediately.",
          "Date format should be DD-MM-YYYY.",
          "Date should be after the current date.",
        ],
      },
      {
        tagName: "Product ID",
        desc: "ID of the product that will be rewarded. Product ID can be found in the same CSV  template.",
        ex: "EX: 12345",
        value: "product_id",
        conditions: [
          "Mandatory.",
          "Max character is 12.",
          "This is the ID of the product you wish to send.",
          "This can be found in the sample CSV template.",
        ],
      },
      {
        tagName: "Product Name",
        desc: "Name of the product that will be rewarded.",
        ex: "EX: Amazon",
        value: "product_name",
        conditions: [
          "Mandatory.",
          "This is the name of the product you wish to send.",
          "This can be found in the sample CSV template.",
        ],
      },
      {
        tagName: "Value of product",
        desc: "Value of the product that will be rewarded.",
        ex: "Ex: 1000",
        value: "amount_plumpro",
        conditions: [
          "Mandatory.",
          "Choose from the available value of the product you wish to send.",
          "This can be found in the sample CSV template.",
        ],
      },
      {
        tagName: "Quantity",
        desc: "No. of vouchers that needs to be sent.",
        ex: "Ex: 10",
        value: "quantity_plumpro",
        conditions: ["Mandatory.", "Between 1 and 100."],
      },
      {
        tagName: "Personal Message",
        value: "message",
        conditions: [
          "Optional.",
          "Max character is 600.",
          "This will be visible only in the email and not supported for mobile SMS.",
        ],
      },
      {
        tagName: "Notes",
        value: "note",
        conditions: [
          "Optional.",
          "Max character is 150.",
          "This will be used for internal reference only.",
        ],
      },
      {
        tagName: "PO number",
        value: "po_number",
        conditions: [
          "Optional.",
          "Purchase order number is a unique identifier for each reward for your internal reference.",
          "Max digit is 100.",
        ],
      },
    ];

    return (
      <StyledModal
        enableOverflow
        isOpen={modal}
        size="lg"
        onClose={() => {
          this.handleModal();
        }}
      >
        <div className="d-flex justify-content-between ">
          <div className="modal-title">
            <Typography.H3 color="ink" shade="normal">
              {this.props.title
                ? `Instructions to send ${this.props.title} in bulk`
                : null}
            </Typography.H3>
            <Typography.HelperText color="dark" shade="c200">
              {` This is a description for each fields included in the CSV/XLSX file for sending  ${
                reward_labels[this.props.rewardType - 1]
              } to multiple recipients.`}
            </Typography.HelperText>
          </div>
          <div>
            <Icon
              iconName="Close"
              size="m"
              color="dark"
              shade="c200"
              className="cursor-pointer"
              onClick={() => {
                this.handleModal();
              }}
            />
          </div>
        </div>
        <hr className="mb-0"></hr>
        <Typography.LabelText className="mt-20" color="dark" shade="c200">
          Number of fields: {this.props.value?.length}{" "}
        </Typography.LabelText>
        <div
          style={{
            maxWidth: "1000px",
            overflow: "scroll",
          }}
        >
          <StyledTable className="my-20">
            <thead>
              {dataModal.map((element) => {
                return this.props.value.indexOf(element.value) !== -1 ? (
                  <StyledRowHead>
                    <Typography.LabelText>
                      {element.tagName}
                    </Typography.LabelText>
                  </StyledRowHead>
                ) : null;
              })}
            </thead>
            <tbody>
              <tr>
                {dataModal.map((element) => {
                  return this.props.value.indexOf(element.value) !== -1 ? (
                    <StyledTd>
                      <StyledList className="d-flex flex-column">
                        {element.conditions.map((el, index) => (
                          <li key={index} className="px-14">
                            <Typography.BodySmall
                              color="dark"
                              shade="c300"
                              component={"div"}
                              className="pt-16"
                            >
                              {el}
                            </Typography.BodySmall>
                          </li>
                        ))}
                      </StyledList>
                    </StyledTd>
                  ) : null;
                })}
              </tr>
            </tbody>
          </StyledTable>
        </div>
        <div className="d-flex justify-content-end pt-24 pb-0">
          
          <Button
            loading={this.props.bulkProductsLoading}
            onClick={() => {
              if (this.props.rewardType === 4)
                this.props.fetchBulkVouhcers();
              else
                this.props.handleUrl();
              }}
              variant="outlined"
            >
              Download CSV Template
            </Button>
          {/* {this.props.rewardType === 4 ? <DownloadSampleProduct
              fromTemplateModal
              voucherProducts={
                this.props.bulkVoucherProducts
                  ? this.props.bulkVoucherProducts
                  : []
              }
            /> : null} */}
        </div>
      </StyledModal>
    );
  }
}
export default TemplateGuideModal;
